{
  "Received": "收币",
  "Transferred": "支付",
  "TransferredWithBonus": "支付",
  "ExchangedIn": "闪兑",
  "BuyOrderCompleted": "买币",
  "SellOrderReserved": "卖币",
  "SellOrderRefunded": "卖币",
  "SellOrderRebated": "卖币",
  "Credited": "增加可用余额",
  "DebitCompleted": "减少可用余额",
  "BonusActivityRewarded": "奖励",
  "SellOrderCompleted": "卖币"
}
